export default "__VITE_ASSET__VKQ9AVZJ__"